var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalytics = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 68,
  height: 68,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 34,
  fill: "#EBF5FA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M17 26.96h8.5v23.19H17zM29.75 21.991h8.5V50.15h-8.5zM42.5 17.85H51v32.3h-8.5z"
})));
export { SvgAnalytics as ReactComponent };
export default __webpack_public_path__ + "static/media/analytics.8dcc9e6f.svg";